import { useLocation } from "@reach/router"
import { Link, StaticQuery, graphql } from "gatsby"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { isIOS } from "react-device-detect"
import Image from "../images/p2-full-logo-white.svg"
import "../styles/header.css"

const Header = ({ data }) => {
  useEffect(() => {
    window.addEventListener("scroll", function () {
      var body = document.body
      if (window.scrollY > 40) {
        body.classList.add("headers-scrolled")
      } else {
        body.classList.remove("headers-scrolled")
      }
    })
    const inViewport = homeparallax => {
      const elements = document.getElementsByClassName(homeparallax)
      let prevElement = null

      const observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              if (!entry.target.classList.contains("active")) {
                entry.target.classList.add("active")
              }

              if (prevElement && prevElement !== entry.target) {
                prevElement.classList.remove("active")
              }

              prevElement = entry.target
            } else {
              if (entry.target.classList.contains("active")) {
                entry.target.classList.remove("active")
              }
            }
          })
        },
        { threshold: 0.4 }
      )

      for (let i = 0; i < elements.length; i++) {
        observer.observe(elements[i])
      }
    }

    inViewport("homeparallax")
  }, [])
  useEffect(() => {
    // Detect iOS devices
    if (isIOS) {
      document.body.classList.add("ios-specific-element")
    }

    // Clean up the added class on component unmount
    return () => {
      if (isIOS) {
        document.body.classList.remove("ios-specific-element")
      }
    }
  }, [])
  const ToggleClass = () => {
    const checkbox = document.getElementById("show-menu")
    const isChecked = checkbox.checked
  }
  const [isMenuOpen, setMenuOpen] = useState(false)
  const toggleMenu = () => {
    setMenuOpen(!isMenuOpen)
  }

  return (
    <>
      <section id="Header" className="header">
        <div className="container">
          <div className="header-wrap">
            <div className="header-logo">
              <Link to="/" className="logo">
                <img src={Image} alt="P2 Logo" />
              </Link>
            </div>
            <div className="header-menu">
              <div id="mainMenuBlock">
                <input
                  type="checkbox"
                  className="sideIconToggle"
                  id="show-menu"
                  checked={isMenuOpen}
                  onChange={toggleMenu}
                />
                <label
                  htmlFor="show-menu"
                  className="show-menu sideIconToggle"
                  onClick={ToggleClass}
                >
                  <span>Menu</span>
                </label>

                <div className={`menu-wrapper ${isMenuOpen ? "show" : ""}`}>
                  <div id="overBG" onClick={toggleMenu}></div>
                  {/* <div className="overlay">
                    <div className="top-menu clearfix">
                      <div className="menu-list">
                        {menuitemheadercontent.edges.map(({ node }, index) => (
                          <div key={index}>
                            {node.childItems.nodes.length ? (
                              <ul className={node.title}>
                                <li>
                                  <Link href={node.path}>{node.label}</Link>
                                </li>
                                <ul>
                                  {node.childItems.nodes.map(
                                    (childdata, index) => (
                                      <li key={index}>
                                        <Link href={childdata.path}>
                                          {childdata.label}
                                        </Link>
                                      </li>
                                    )
                                  )}
                                </ul>
                              </ul>
                            ) : null}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div> */}
                  <div class="overlay">
                    <div class="top-menu clearfix">
                      <div class="menu-list">
                        <div></div>
                        <div>
                          <ul>
                            <li>
                              <a href="#">Content &amp; Creative</a>
                            </li>
                            <ul>
                              <li>
                                <a href="/web-design-and-development/">
                                  Web & Apps
                                </a>
                              </li>
                              <li>
                                <a href="/web-master-services/">
                                  Webmaster Services
                                </a>
                              </li>
                              <li>
                                <a href="/copy-writing/">Copywriting</a>
                              </li>
                              <li>
                                <a href="/3d-solutions/">3D Solutions</a>
                              </li>
                              <li>
                                <a href="/creative-assets/">Creative Assets</a>
                              </li>
                              <li>
                                <a href="/video-marketing/">Video Marketing</a>
                              </li>
                            </ul>
                          </ul>
                        </div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div>
                          <ul class="Services">
                            <li>
                              <a href="/demandbase">Demand Generation</a>
                            </li>
                            <ul>
                              <li>
                                <a href="/paid-marketing/">Paid Marketing</a>
                              </li>
                              <li>
                                <a href="/seo/">SEO</a>
                              </li>
                              <li>
                                <a href="/marketing-automation/">
                                  Marketing Automation
                                </a>
                              </li>
                              <li>
                                <a href="https://p2-revamp.netlify.app/account-based-marketing/">
                                  Account-based Marketing
                                </a>
                              </li>
                            </ul>
                          </ul>
                        </div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div>
                          <ul>
                            <li>
                              <a href="#">Digital Consulting</a>
                            </li>
                            <ul>
                              <li>
                                <a href="/strategic-planning/">
                                  Strategic Planning
                                </a>
                              </li>
                              <li>
                                <a href="/cro/">Conversion Rate Optimization</a>
                              </li>
                              <li>
                                <a href="/marketing-analytics/">
                                  Audit, Reporting, Analytics &amp; Attribution
                                </a>
                              </li>
                            </ul>
                          </ul>
                        </div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div>
                          <ul class="Industries">
                            <li>
                              <a href="#">Industries</a>
                            </li>
                            <ul>
                              <li>
                                <a href="/saas/">SaaS</a>
                              </li>
                              <li>
                                <a href="/cybersecurity/">Cybersecurity</a>
                              </li>
                              <li>
                                <a href="/fintech/">FinTech</a>
                              </li>
                            </ul>
                          </ul>
                        </div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div>
                          <ul class="Agency">
                            <li>
                              <a href="#">AI in Growth Marketing</a>
                            </li>
                            <ul>
                              <li>
                                <a href="https://p2-revamp.netlify.app/ai-growth-tech/">
                                  AI GrowthTech &amp; Use cases
                                </a>
                              </li>
                            </ul>
                          </ul>
                        </div>
                        <div></div>
                        <div>
                          <ul class="Partners">
                            <li>
                              <a href="#">Partners</a>
                            </li>
                            <ul>
                              <li>
                                <a href="/conversica/">Conversica</a>
                              </li>
                              <li>
                                <a href="/demandbase/">Demandbase</a>
                              </li>
                            </ul>
                          </ul>
                        </div>
                        <div></div>
                        <div></div>
                        <div>
                          <ul class="Products">
                            <li>
                              <a href="#">About Us</a>
                            </li>
                            <ul>
                              <li>
                                <a href="/about-us/">Who We Are</a>
                              </li>
                              <li>
                                <a href="/leadership-team/">Leadership Team</a>
                              </li>
                              <li>
                                <a href="/careers/">Careers</a>
                              </li>
                              <li>
                                <a href="/podcast/">Podcast</a>
                              </li>
                              <li>
                                <a href="/blog">Blog</a>
                              </li>
                            </ul>
                          </ul>
                        </div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div>
                          <ul class="arena">
                            <li>
                              <a href="/arena-calibrate/">Arena</a>
                            </li>
                            {/* <ul>
                              <li>
                                <a href="/arena-calibrate/">Arena</a>
                              </li>
                            </ul> */}
                          </ul>
                        </div>
                        <div></div>
                        <div>
                          <ul class="get-in-touchcta">
                            <li>
                              <a href="/contact-us">Get In Touch</a>
                            </li>
                            <ul>
                              <li>
                                <a href="tel:+18007255507">
                                  Toll-free (US): 800-725-5507
                                </a>
                              </li>
                              <li>
                                <a href="mailto:info@position2.com">
                                  info@position2.com
                                </a>
                              </li>
                            </ul>
                          </ul>
                        </div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
export default function HeaderBlock(props) {
  return (
    <StaticQuery
      query={graphql`
        query {
          menuitemheader: allWpMenuItem {
            edges {
              node {
                label
                path
                id
                cssClasses
                title
                childItems {
                  nodes {
                    label
                    path
                  }
                }
              }
            }
          }
          headerblock: allWpPage(filter: { id: { eq: "cG9zdDoxMDA4" } }) {
            edges {
              node {
                id
                title
                singleBlockLayoutSection {
                  textArea
                }
              }
            }
          }
        }
      `}
      render={data => <Header data={data} {...props} />}
    />
  )
}
Header.propTypes = {
  data: PropTypes.shape({
    site: PropTypes.shape({
      siteMetadata: PropTypes.shape({
        title: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
}
